import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface CreateSprintModalProps {
    show: boolean;
    onHide: () => void;
    onSprintCreate: (sprint: { name: string; startDate: string; endDate: string }) => void;
}

const CreateSprintModal: React.FC<CreateSprintModalProps> = ({ show, onHide, onSprintCreate }) => {
    const [name, setName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSprintCreate({ name, startDate, endDate });
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Create New Sprint</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="sprintName">
                        <Form.Label>Sprint Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="startDate">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="endDate">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        Create Sprint
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateSprintModal;
